/* @flow */
/** @jsx h */
import { h } from 'preact';
import cssStyles from './index.css';
import { RootStore } from '../../js/stores/root.store';

interface BrandBarProps {
  colors: {
    primaryColor: string;
  };
}

export default function BrandBar({ colors }: BrandBarProps) {
  const { logo, domain, name } =
    RootStore.getInstance().configStore.config.brandItem ?? {};

  const { primaryColor } = colors;

  return (
    <div className={cssStyles.brandbar}>
      <div className={cssStyles.brandbarLogoContainer}>
        {logo ? (
          <img className={cssStyles.brandbarLogo} src={logo} alt="logo" />
        ) : (
          ''
        )}
        <div className={cssStyles.brandbarColumn}>
          <div className={cssStyles.brandbarName}>{name}</div>
          {domain ? (
            <div
              className={cssStyles.brandbarDomain}
              style={{ color: primaryColor }}
            >
              {domain}
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
}
